import { ICustomElementViewModel, inject, bindable } from 'aurelia';
import { Helper } from '../../extensions';
import './db-footer-accordion.scss';

@inject(Helper)
export class DbFooterAccordion implements ICustomElementViewModel {
    @bindable title: string;
    @bindable links: { name: string; routeName: string }[];
    @bindable dropdown: {
        name: string;
        isDropdownMenu?: boolean;
        showFilter?: boolean;
        keyName?: string;
        menuItems: { name: string; routeName: string }[];
    };

    environmentLink: string;
    isExpanded: boolean = false;
    keyword: string;
    results: boolean;
    filteredItems: { name: string; routeName: string }[] = [];
    openMenu: boolean = false;

    constructor(private helper: Helper) {
        this.environmentLink = this.helper.environmentLink;
    }

    toggleAccordion() {
        this.isExpanded = !this.isExpanded;
    }

    keywordChanged(value: Event, dropdownMenu: { name: string; routeName: string }[]) {
        const key = (value.target as HTMLInputElement).value.toLowerCase();
        this.filteredItems = dropdownMenu.filter((data) => data.name.toLowerCase().includes(key));

        if (this.filteredItems.length > 0) {
            this.results = false;
        } else if (this.filteredItems.length === 0) {
            this.results = true;
        }
    }

    menuTrigger() {
        this.openMenu = !this.openMenu;
    }
}
